import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export function features() {
  new Swiper('.features__swiper', {
    modules: [Pagination],
    spaceBetween: 12,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      450: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 5,
      },
    },
  });
}
